import {
    ApolloClient,
    InMemoryCache,
    createHttpLink,
    split,
} from "@apollo/client";

import {getMainDefinition} from "@apollo/client/utilities";
import {LOCAL_STORAGE_KEYS} from "../common/constants";
import {ApolloLink} from "@apollo/client";
import {GraphQLWsLink} from "@apollo/client/link/subscriptions";
import {createClient} from "graphql-ws";
import {
    authLink,
    errorLink,
    testTokenRefresh,
    simulateExpiredToken,
    simulateForbiddenError,
    checkTokenStatus
} from "./authLink";

// Export the test utilities for development use
export {testTokenRefresh, simulateExpiredToken, simulateForbiddenError, checkTokenStatus};

export const endpoint =
    process.env.REACT_APP_GRAPHQL_ENDPOINT || `https://api.stg.robinfood.dev`;

const wsEndpoint =
    process.env.REACT_APP_GRAPHQL_WS_ENDPOINT || `wss://api.stg.robinfood.dev`;

const appToken = process.env.REACT_APP_APP_TOKEN;

function createWSLink() {
    const wsUrl = `${wsEndpoint}/graphql`;

    return new GraphQLWsLink(
        createClient({
            url: wsUrl,
            connectionParams: () => {
                const token = localStorage.getItem(LOCAL_STORAGE_KEYS.SESSION_TOKEN);
                return {
                    headers: {
                        authorization: token ? `Bearer ${token}` : "",
                        ...(appToken ? {"x-app-token": appToken} : {}),
                    },
                };
            },
            retryAttempts: 3,
            shouldRetry: () => false, // Disable retries to avoid console spam
            on: {
                error: (error) => {
                    console.warn('WebSocket connection error (subscriptions disabled):', error);
                },
                closed: (event: CloseEvent | any) => {
                    if (event?.code !== 1000) { // Only log if not normal closure
                        console.warn('WebSocket connection closed unexpectedly:', event);
                    }
                },
            },
        })
    );
}

function createGraphQLHttpLink() {
    return createHttpLink({
        uri: `${endpoint}/graphql`,
    });
}

export function createApolloClient() {
    // Create links
    const httpLink = createGraphQLHttpLink();
    const wsLink = createWSLink();

    // Split between WebSocket (for subscriptions) and HTTP (for queries/mutations)
    const splitLink = split(
        // Split based on operation type
        ({query}) => {
            const definition = getMainDefinition(query);
            return (
                definition.kind === "OperationDefinition" &&
                definition.operation === "subscription"
            );
        },
        wsLink,
        httpLink
    );

    return new ApolloClient({
        link: ApolloLink.from([errorLink, authLink, splitLink]),
        cache: new InMemoryCache(),
    });
}
